import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VTextField,
    _vm._g(
      _vm._b(
        {
          staticClass: "time-input",
          attrs: {
            value: _vm.value,
            "clear-icon": "ui-icon-close-not-a-circle",
            "hide-details": "",
            clearable: "",
            outlined: "",
            type: "time",
            required: "",
          },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event || "")
            },
            "click:clear": function ($event) {
              return _vm.$emit("input", "")
            },
          },
        },
        "v-text-field",
        _vm.$attrs,
        false
      ),
      { ..._vm.$listeners }
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }